export default "__VITE_ASSET__DByD0qdg__"